export const SLATE_DEFAULT_BLOCK_TYPE = 'paragraph';

export const SLATE_BLOCK_PARENT_TYPES = ['list-item', 'quote'];
